// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColumnsSelector_wrapper__ctGxx","paper":"ColumnsSelector_paper__e-910","list":"ColumnsSelector_list__3r1hP","item":"ColumnsSelector_item__1Oiuf"};